import { ReactElement } from 'react';

import { Canvas } from '../components/Canvas';
import { MainHero } from '../components/MainHero';
import { MainHeroImage } from '../components/MainHeroImage';

export const Home = (): ReactElement => {
    return (
        <div className={'bg-background overflow-hidden'}>
            <div className={'relative bg-background'}>
                <div className='max-w-7xl mx-auto'>
                    <div
                        className={'relative z-10 pb-8 bg-background sm:pb-16 md:pb-20 lg:max-w-2xl lg:w-full lg:pb-28 xl:pb-32'}
                    >
                        <MainHero />
                    </div>
                </div>
                <MainHeroImage />
            </div>
            <Canvas />
            {/*<LazyShow>*/}
            {/*    <>*/}
            {/*        <Product />*/}
            {/*        <Canvas />*/}
            {/*    </>*/}
            {/*</LazyShow>*/}
            {/*<LazyShow>*/}
            {/*    <>*/}
            {/*        <Features />*/}
            {/*        <Canvas />*/}
            {/*    </>*/}
            {/*</LazyShow>*/}
            {/*<Analytics />*/}
        </div>
    );
};
